import { Component, effect, input, signal } from '@angular/core';
import { Router, RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from '../../../../_services/route-reuse.strategy';
import { IMenuItem } from '../side-menu/side-menu.component';

@Component({
    selector: 'lokos-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrl: './menu-item.component.scss',
    standalone: false
})
export class MenuItemComponent {
    collapsed = input(false);
    item = input.required<IMenuItem>();
    level = input.required<number>();
    menuPaths = input<string[]>([]);
    nestedMenuOpen = signal(false);

    constructor (
        private readonly router: Router,
        private readonly routeReuseStrategy: RouteReuseStrategy,
    ) {
        effect(() => {
            if (this.collapsed()) {
                this.nestedMenuOpen.set(false);
            }
        }, { allowSignalWrites: true });
    }

    /** Sidebar click on a leaf menu link: force fresh entry by evicting any
     *  cached instance of the target route. Parent items (with children) just
     *  toggle the submenu and never reach this. */
    onLeafNavigate(path?: string): void {
        if (!path) return;
        (this.routeReuseStrategy as CustomRouteReuseStrategy).clearFor?.(path);
    }

    itemClasses (item: IMenuItem): Record<string, boolean> {
        const active = this.isActive(item);
        return {
            'active': active,
            'active0': this.level() === 0 && active && !!item.children
        };
    }

    isActive (item: IMenuItem): boolean {
        const currentUrl = this.router.url.split('?')[0];
        if (item.children?.length) {
            return item.children.some(sub => this.isActive(sub));
        }
        if (!item.path) return false;
        const bestMatch = this.getBestMatchingPath(currentUrl);
        return bestMatch === item.path;
    }

    private getBestMatchingPath (currentUrl: string): string | null {
        let best: string | null = null;
        for (const path of this.menuPaths()) {
            if (currentUrl === path || currentUrl.startsWith(`${path}/`)) {
                if (!best || path.length > best.length) best = path;
            }
        }
        return best;
    }

    toggleNestedMenu (event: Event) {
        if (!this.item().children) {
            return;
        }
        event.stopPropagation();
        this.nestedMenuOpen.set(!this.nestedMenuOpen());
    }
}
